export const RESOLUTION_TABLE_COLUMNS = [
  {
    key: 'laborValue',
    label: 'Valor do orçamento',
    type: 'currency',
    defaultValue: null,
    required: true,
    placeholder: 'R$ 0,00',
    style: {
      flex: 4,
      maxWidth: '280px',
    },
    prefix: 'R$ ',
  },
]

export const RESOLUTION_TABLE_DEFAULT_ITEM = Object.fromEntries(
  RESOLUTION_TABLE_COLUMNS.map(column => [column.key, null])
)
